import type { TypePolicies } from '@apollo/client';

export const IdentityUser: TypePolicies['IdentityUser'] = {
  fields: {
    interactionPermissions: {
      merge: true,
    },
  },
};
